import BrandComponents from "../../Masters/Brand/BrandComponents";

function BomTable() {
  let header = [
    { label: "Id", field: "id" },
    { label: "BOM Name", field: "bomname" },
    { label: "job no.", field: "jobnumber" },
    { label: "part no.", field: "partno" },
    { label: "Size", field: "size" },
    { label: "Created Date", field: "createddate" },
    { label: "Created by", field: "createbyname" },
  ];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"BILL OF MATERIAL (BOM) LIST"}
        apiField={"bom"}
        addButton={"+ ADD"}
        createRoute={"/BOMCreate"}
        viewRoute={"/BOMView"} 
      />
    </div>
  );
}

export default BomTable;